import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule, ControlContainer, FormGroupDirective, FormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxFormFieldComponent } from '../fields/checkbox-form-field/checkbox-form-field.component';
import { DatepickerFormFieldComponent } from '../fields/datepicker-form-field/datepicker-form-field.component';
import { InputFormFieldComponent } from '../fields/input-form-field/input-form-field.component';

@Component({
  selector: 'app-case-record-apps-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputFormFieldComponent,
    DatepickerFormFieldComponent,
    CheckboxFormFieldComponent,
    TranslateModule
  ],
  templateUrl: './case-record-apps-form.component.html',
  styleUrl: './case-record-apps-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class CaseRecordAppsFormComponent implements OnInit {
  @Input() viewMode!: boolean;

  form: any;

  
  constructor(
    public mainForm: FormGroupDirective
  ) {}

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form = this.mainForm.form;

    this.form.addControl('engageApps', new FormControl(false, []));
    this.form.addControl('engageAppsDate', new FormControl({ value: null, disabled: true }, []));
    this.form.addControl('appsAdditionalInfo', new FormControl(null, []));

  }
}
